export function findCategoryById(_a) {
    var category = _a.category, id = _a.id;
    if (category.id === id) {
        return category;
    }
    if (!category.categories || !category.categories.length) {
        return null;
    }
    for (var _i = 0, _b = category.categories; _i < _b.length; _i++) {
        var nextCategory = _b[_i];
        if (nextCategory.id === id) {
            return nextCategory;
        }
        var found = findCategoryById({ category: nextCategory, id: id });
        if (found)
            return found;
    }
    return null;
}
